module.exports = "<sc-frame-view class=\"maximize\" src=\"$ctrl.src\" maximize=\"$ctrl.maximize\" min-height=\"$ctrl.minHeight\" cancelled=\"$ctrl.filterData.cancelled\" on-frame-create=\"$ctrl.onFrameCreate(frame)\" on-frame-load=\"$ctrl.onFrameLoad(frame)\"></sc-frame-view>"


//////////////////
// WEBPACK FOOTER
// ./src/view/report-frame-view.component.html
// module id = 483
// module chunks = 0